import React from 'react';

import { Icon } from '../icons';

export const NoInteractionIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" fill={color} style={style}>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.61249 21.0872C5.5491 19.3918 4.22476 17.4058 3.79445 16.0512C4.39784 14.7149 5.76031 12.7011 7.77063 10.9874C9.89209 9.17906 12.6805 7.75 16 7.75C19.3195 7.75 22.1079 9.17906 24.2294 10.9874C26.2397 12.7011 27.6022 14.7149 28.2056 16.0512C27.7752 17.4058 26.4509 19.3918 24.3875 21.0872C22.2224 22.8661 19.3322 24.25 16 24.25C12.6678 24.25 9.77759 22.8661 7.61249 21.0872ZM16 6.25C12.2286 6.25 9.10791 7.87649 6.79755 9.84589C4.49654 11.8073 2.94497 14.1537 2.30584 15.716L2.21231 15.9447L2.27295 16.1841C2.71841 17.9431 4.31634 20.3203 6.66024 22.2462C9.02545 24.1895 12.2413 25.75 16 25.75C19.7587 25.75 22.9746 24.1895 25.3398 22.2462C27.6837 20.3203 29.2816 17.9431 29.727 16.1841L29.7877 15.9447L29.6942 15.716C29.055 14.1537 27.5035 11.8073 25.2024 9.84589C22.8921 7.87649 19.7714 6.25 16 6.25ZM16 13.5C16 14.8807 14.8807 16 13.5 16C12.4856 16 11.6123 15.3958 11.2203 14.5276C11.0771 14.9931 11 15.4876 11 16C11 18.7614 13.2386 21 16 21C18.7614 21 21 18.7614 21 16C21 13.2386 18.7614 11 16 11C15.4876 11 14.9931 11.0771 14.5277 11.2203C15.3958 11.6123 16 12.4856 16 13.5Z"
        />
      </g>
    </svg>
  );
};
